import React, { useEffect } from 'react';
import CustomNode from './CustomNode.tsx';
import { SankeyNodeProps } from './types.ts';

const SankeyNode: React.FC<SankeyNodeProps> = ({
  nodeProps,
  isFirstNode,
  setNodePosition,
  nodePosition,
  currentNode,
}) => {
  useEffect(() => {
    if (isFirstNode && !nodePosition) {
      setNodePosition({
        x: nodeProps.x,
        y: nodeProps.y,
        height: nodeProps.height,
      });
    }
  }, [isFirstNode, nodeProps, nodePosition, setNodePosition]);

  return (
    <g>
      <CustomNode
        x={nodeProps.x}
        y={nodeProps.y}
        width={nodeProps.width}
        height={nodeProps.height}
        color={currentNode.color}
      />
    </g>
  );
};

export default SankeyNode;
